import PageContainer from 'src/pages/components/PageContainer';
import EezyGuardOccurrenceDetail from 'src/pages/components/eezyguard/EezyGuardOccurrenceDetail';
import { useEezyguardAdmin } from 'src/pages/components/eezyguard/common';

export default function EezyGuardAdminOccurrenceDetail(): JSX.Element {
  const { isAdmin } = useEezyguardAdmin();

  return (
    <PageContainer title="Ocorrência" guard={() => isAdmin}>
      <EezyGuardOccurrenceDetail scope="admin" />
    </PageContainer>
  );
}
